import { createSelector } from '@reduxjs/toolkit'
import type { State } from '../index.js'
import type { VisualizationSampleContainer } from '../../../View/Component/SampleGrouping/VisualizationSampleContainer.js'
import type { ProjectOrder } from '../../../Model/Project/IProjectSample.js'

const selectScope = (s: typeof State) => s.visualization.scope
const selectProjectSamples = (s: typeof State) => s.project.currentSamples
const selectProjectOrders = (s: typeof State) => s.project.projectOrders
const selectOrder = (s: typeof State) => (s.order?.order === 'LOADING' ? undefined : s.order?.order)
const selectOrderSamplePools = (s: typeof State) => s.order?.samplePools

export const selectVizSamples = createSelector(
  [selectScope, selectProjectSamples, selectProjectOrders, selectOrder, selectOrderSamplePools],
  (scope, projectSamples, projectOrders, order, samplePools): VisualizationSampleContainer[] => {
    if (!scope) return []

    if (scope.kind === 'project') {
      if (projectSamples === 'LOADING' || projectOrders === 'LOADING') return []

      const byId: Record<string, ProjectOrder> = {}
      for (const o of projectOrders) byId[o.anonymousOrder.id] = o

      return projectSamples.map((ps) => {
        const full = ps.sample
        const po = full.orderId ? byId[full.orderId] : undefined
        return {
          ...full,
          projectSample: ps,
          baseOrder: po?.anonymousOrder,
          order: po?.fullOrder
        }
      })
    }

    // order scope
    if (!order || samplePools === 'LOADING' || !Array.isArray(samplePools)) return []
    return samplePools.flatMap((pool) =>
      pool.samples.map((s) => ({
        ...s,
        baseOrder: order,
        order: order
      }))
    )
  }
)
